var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social / Facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M20 40.25C9.09238 40.25 0.25 31.4076 0.25 20.5C0.25 9.59238 9.09238 0.75 20 0.75C30.9076 0.75 39.75 9.59238 39.75 20.5C39.75 31.4076 30.9076 40.25 20 40.25Z",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "facebook",
    d: "M28 20.5C28 16.375 24.625 13 20.5 13C16.375 13 13 16.375 13 20.5C13 24.25 15.7187 27.3438 19.2812 27.9062V22.6562H17.4062V20.5H19.2812V18.8125C19.2812 16.9375 20.4063 15.9063 22.0938 15.9063C22.9375 15.9063 23.7812 16.0938 23.7812 16.0938V17.9688H22.8438C21.9062 17.9688 21.625 18.5312 21.625 19.0938V20.5H23.6875L23.3125 22.6562H21.5312V28C25.2812 27.4375 28 24.25 28 20.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.40f2e9b154ad63eb804220c515f72b33.svg";
export { ForwardRef as ReactComponent };